<template>
  <div class="section-comments" v-if="showSection">
    <div class="nav">
      <p class="nav-title">评论区</p>
    </div>
    <com-comment 
      v-for="comment, index in sectionData.comments" 
      :key="index"
      :comment="comment" 
    ></com-comment>

    <!-- <div class="link-btn-box">
      <div class="link-btn" @click="openInApp">
        打开
        {{ openAppText }}
        ，查看更多精彩评论
        <OutOpen :protocol="heybox_protocol" :page-identifier="'bbs/link'"  v-deeplink></OutOpen>
      </div>
    </div> -->
  </div>
</template>
<script>
import ComComment from '../components/com-comment.vue'
export default {
  components: {
    ComComment
  },
  props: {
    comments: {
      type: Array,
      default: () => ([])
    }
  },
  methods: {
    // 处理评论
    handleComments (comments) {
      return comments.map(item => {
        let list_1 = item.comment[0]
        this.$set(list_1, 'show', true)
        this.$set(list_1, 'islike', false)
        this.$set(list_1, 'unlike', false)
        return item.comment
      })
    },
  },
  computed: {
    showSection () {
      return this.comments && this.comments.length != 0
    },
    sectionData () {
      return {
        comments: this.handleComments(this.comments)
      }
    },
  }
}
</script>
<style lang="less">
.section-comments {
  position: relative;
  padding-top: 4px;
  width: 100%;
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 4px;
    background: #FAFBFC;
  }
  .nav {
    position: relative;
    padding: 14px 10px;
    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      display: block;
      height: 1px;
      width: 100%;
      transform: scaleY(.5);
      background: #F3F4F5;
    }
    .nav-title {
      font-size: 14px;
      font-weight: bold;
      color: #14191e;
    }
  }
  .link-btn-box {
    padding: 14px 20px;
    .link-btn {
      position: relative;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 500;
      text-align: center;
      line-height: 40px;
      color: #FFFFFF;
      background: #14191e;
    }
  }
}
</style>